/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PdpmEstimatorComponentReferenceMeta
 */
export interface PdpmEstimatorComponentReferenceMeta {
    /**
     * 
     */
    component: string;
    /**
     * 
     */
    case_mix_group: string | null;
    /**
     * 
     */
    case_mix_index: number | null;
    /**
     * 
     */
    case_mix_daily_rate: number;
}

/**
 * Check if a given object implements the PdpmEstimatorComponentReferenceMeta interface.
 */
export function instanceOfPdpmEstimatorComponentReferenceMeta(value: object): value is PdpmEstimatorComponentReferenceMeta {
    if (!('component' in value) || value['component'] === undefined) return false;
    if (!('case_mix_group' in value) || value['case_mix_group'] === undefined) return false;
    if (!('case_mix_index' in value) || value['case_mix_index'] === undefined) return false;
    if (!('case_mix_daily_rate' in value) || value['case_mix_daily_rate'] === undefined) return false;
    return true;
}

export function PdpmEstimatorComponentReferenceMetaFromJSON(json: any): PdpmEstimatorComponentReferenceMeta {
    return PdpmEstimatorComponentReferenceMetaFromJSONTyped(json, false);
}

export function PdpmEstimatorComponentReferenceMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PdpmEstimatorComponentReferenceMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'component': json['component'],
        'case_mix_group': json['case_mix_group'],
        'case_mix_index': json['case_mix_index'],
        'case_mix_daily_rate': json['case_mix_daily_rate'],
    };
}

export function PdpmEstimatorComponentReferenceMetaToJSON(json: any): PdpmEstimatorComponentReferenceMeta {
    return PdpmEstimatorComponentReferenceMetaToJSONTyped(json, false);
}

export function PdpmEstimatorComponentReferenceMetaToJSONTyped(value?: PdpmEstimatorComponentReferenceMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'component': value['component'],
        'case_mix_group': value['case_mix_group'],
        'case_mix_index': value['case_mix_index'],
        'case_mix_daily_rate': value['case_mix_daily_rate'],
    };
}

